import React from "react";
import HeroSection from "./HeroSection";
import { HomeWrapper, Intro } from "./HomeElement";
import myImage from "../../assets/hero-image.png";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

const Hero = () => {
  const { mode } = React.useContext(ThemeContext);
  const handleGithub = () => {
    window.open("https://github.com/kumarrohan2804");
  };
  const handleTwitter = () => {
    window.open("https://twitter.com/rohan_kumar28");
  };
  const handleLinkedin = () => {
    window.open("https://www.linkedin.com/in/rohan-kumar-baranwal-a25313148/");
  };
  const handleResume = () => {
    window.open(
      "https://drive.google.com/file/d/15WSjgCr1o_5hzZKxavflZQfmau9YtFdd/view?usp=sharing"
    );
  };

  return (
    <HomeWrapper id="home">
      <img
        className="svg-rect"
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzI1IiBoZWlnaHQ9Ijk5MCIgdmlld0JveD0iMCAwIDcyNSA5OTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjY2My45NzMiIHk9Ii00NTQiIHdpZHRoPSIxMjcwLjAzIiBoZWlnaHQ9IjkzOSIgcng9IjE1IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA2NjMuOTczIC00NTQpIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI2NjMuOTczIiB5MT0iLTQ1NCIgeDI9IjE1NTkuNjMiIHkyPSI3NTcuNDEyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2QTk4RjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDk2MURDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=="
        alt=""
        style={{ zIndex: "4" }}
      ></img>

      <Intro theme={mode}>
        <div className="home__text">
          <div className="imageContainer">
            <img src={myImage} alt="lo" />
          </div>
          <p className="hello">Hello, I’m</p>
          <h1>Rohan Kumar Baranwal</h1>
          <p className="adjust">FULL-STACK DEVELOPER</p>
          <div className="home__CTA">
            <button className="cta" as="a" onClick={handleResume}>
              Download Resume
            </button>

            <div className="home__social">
              <FaGithub onClick={handleGithub} />
              <FaLinkedin onClick={handleLinkedin} />
              <FaTwitter onClick={handleTwitter} />
            </div>
          </div>
        </div>
        <HeroSection />
      </Intro>
    </HomeWrapper>
  );
};

export default Hero;
